<div class="docs-wrapper" [class.light-mode]="!isDarkMode">
    <aside class="sidebar">
        <div class="theme-switch-container">
            <button class="theme-toggle" (click)="toggleTheme()" [title]="isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
                <svg *ngIf="isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
                <svg *ngIf="!isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
            </button>
        </div>
        <div class="logo">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
            PDMS <span>Docs</span>
        </div>
        
        <div class="nav-group">
            <div class="nav-title">Introducción</div>
            <a (click)="scrollToSection('overview')" href="javascript:void(0)" class="nav-link active">Vista General</a>
            <a (click)="scrollToSection('architecture')" href="javascript:void(0)" class="nav-link">Arquitectura del Hub</a>
        </div>

        <div class="nav-group">
            <div class="nav-title">API Reference</div>
            <a (click)="scrollToSection('endpoint-general')" href="javascript:void(0)" class="nav-link">Advanced Search General</a>
            <a (click)="scrollToSection('parameters')" href="javascript:void(0)" class="nav-link">Parámetros</a>
            <a (click)="scrollToSection('responses')" href="javascript:void(0)" class="nav-link">Respuestas</a>
        </div>

        <div class="nav-group">
            <div class="nav-title">Librerías</div>
            <a (click)="scrollToSection('lib-fin')" href="javascript:void(0)" class="nav-link">Process</a>
            <a (click)="scrollToSection('lib-ccp')" href="javascript:void(0)" class="nav-link">HOE</a>
            <a (click)="scrollToSection('lib-master')" href="javascript:void(0)" class="nav-link">Librerías Dinámicas</a>
        </div>
    </aside>

    <main class="main-content">
        <section id="overview">
            <h1>Búsqueda Avanzada</h1>
            <p>El sistema de búsqueda avanzada de PDMS permite localizar documentos de forma eficiente a través de múltiples repositorios, filtrando por metadatos técnicos y, opcionalmente, por el contenido textual de los archivos.</p>
            
            <div class="alert">
                <span class="alert-title">Nota sobre el Alcance</span>
                La búsqueda avanzada está diseñada para trabajar sobre las versiones <b>vigentes</b> de los documentos (donde <code>ID_Next_Version</code> es nulo) y que no han sido eliminados del sistema.
            </div>
        </section>

        <section id="architecture">
            <h2>Arquitectura del Hub</h2>
            <p>A diferencia de las búsquedas simples, el sistema utiliza un modelo de <b>Orquestación Centralizada</b>. El frontend se comunica con un único punto de entrada que distribuye la carga:</p>
            
            <pre><code>// Flujo de Ejecución
1. Cliente -> POST /Advanced_Search_General
2. Hub -> Identifica librerías solicitadas (Process, HOE, Master)
3. Hub -> Ejecuta búsquedas en paralelo
4. Hub -> Consolida resultados y retorna al Cliente</code></pre>
        </section>

        <section id="endpoint-general">
            <h2>Advanced Search General</h2>
            <p><span class="method">POST</span> <code>/_api/V6.3.0/GENERALCDMS/Advanced_Search_General</code></p>
            <p>Este es el endpoint principal que unifica la experiencia de búsqueda global.</p>

            <h3 id="parameters">Cuerpo de la Petición (Request Body)</h3>
            <table>
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><code class="highlight">Name</code></td>
                        <td>String</td>
                        <td>Término de búsqueda (Nombre o Contenido).</td>
                    </tr>
                    <tr>
                        <td><code>Extension</code></td>
                        <td>String</td>
                        <td>Filtro por extensión (ej. ".pdf", ".docx").</td>
                    </tr>
                    <tr>
                        <td><code>Library</code></td>
                        <td>Number[]</td>
                        <td>Lista de IDs de las librerías donde buscar.</td>
                    </tr>
                    <tr>
                        <td><code>SearchContent</code></td>
                        <td>Boolean</td>
                        <td>Activa la búsqueda dentro del contenido (Markdown).</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <section id="responses">
            <h3>Ejemplo de Petición</h3>
            <pre><code>&#123;
  "Name": "Factura",
  "Extension": ".pdf",
  "Library": [2, 5],
  "SearchContent": true
&#125;</code></pre>

            <h3>Ejemplo de Respuesta</h3>
            <pre><code>&#123;
  "success": true,
  "operation": [
    &#123;
      "ID": 125,
      "Name": "Factura_Proveedor_A.pdf",
      "Extension": "pdf",
      "Status": 1,
      "Contributor_Name": "Juan Pérez",
      "Path": "2024/Finanzas/Facturas",
      "Library": 5
    &#125;
  ],
  "message": "RETURN ALL DOCUMENTS"
&#125;</code></pre>
        </section>

        <section id="lib-fin">
            <h2>Librería Process</h2>
            <p>La búsqueda en <b>Process</b> (módulo FIN) utiliza la vista <code>Info_Of_FIN</code> para garantizar que se obtengan todos los metadatos relacionados al flujo de trabajo (Workflow).</p>
            <p>Cuando <code class="highlight">SearchContent</code> es verdadero, el sistema ejecuta una subconsulta sobre la columna <code>Markdown</code> de la tabla de Workflow.</p>
        </section>

        <section id="lib-ccp">
            <h2>Librería HOE</h2>
            <p>Actualmente, la búsqueda en <b>HOE</b> (módulo CCP) está optimizada para metadatos de proceso. A diferencia de Process, esta librería busca exclusivamente por nombre y extensión en la tabla <code>Info_Of_HOE</code>.</p>
        </section>

        <section id="lib-master">
            <h2>Librerías Dinámicas (Master)</h2>
            <p>Para las librerías creadas por el usuario, el sistema resuelve dinámicamente el nombre de la base de datos y las tablas de destino usando el <b>Slug</b> de la librería.</p>
            <p>Este módulo también soporta la búsqueda avanzada por contenido en archivos procesados por OCR o IA.</p>
        </section>

        <footer style="margin-top: 5rem; padding-top: 2rem; border-top: 1px solid var(--border-color); color: var(--text-secondary); font-size: 0.875rem;">
            &copy; 2026 PDMS Documentation System. Todos los derechos reservados.
        </footer>
    </main>
</div>
